/**
 * Safe default factories for seller intake contract objects (Sell Your Car M2).
 */
import {
  SELLER_DEFAULT_CURRENCY,
  SELLER_OWNERSHIP_STATUSES,
  SELLER_PREFERRED_CONTACT_METHODS,
  SELLER_SUBMISSION_STATUSES,
  SELLER_TYPES,
  SELLER_FIELD_LABELS_ES,
} from "./sellerIntakeConstants";
import { SELLER_RESULT_CODES } from "../../intl/validationMessages.js";

/**
 * @returns {import('./sellerIntakeTypes').SellerSubmissionInput}
 */
export function createEmptySellerSubmissionInput() {
  return {
    sellerType: SELLER_TYPES.INDIVIDUAL,
    sellerName: "",
    sellerPhone: "",
    sellerEmail: "",
    preferredContactMethod: SELLER_PREFERRED_CONTACT_METHODS.WHATSAPP,
    city: "",
    department: "",
    vehicleMake: "",
    vehicleModel: "",
    vehicleYear: null,
    vehicleTrim: "",
    vehicleMileageKm: null,
    askingPrice: null,
    currency: SELLER_DEFAULT_CURRENCY,
    conditionSummary: "",
    ownershipStatus: SELLER_OWNERSHIP_STATUSES.UNKNOWN,
    plate: "",
    vin: "",
    hasPhotos: false,
    notes: "",
    consentAccepted: false,
    marketingOptIn: false,
    honeypot: "",
  };
}

/**
 * @returns {import('./sellerIntakeTypes').SellerSubmissionResult}
 */
export function createDefaultSellerSubmissionResult() {
  return {
    ok: false,
    status: SELLER_SUBMISSION_STATUSES.UNKNOWN_ERROR,
    submissionId: null,
    sellerMessage: null,
    retryable: false,
    fieldErrors: [],
    errorCategory: null,
    submittedAt: null,
  };
}

/**
 * @param {import('./sellerIntakeTypes').SellerSubmissionStatus} status
 * @returns {import('./sellerIntakeTypes').SellerSubmissionResult}
 */
export function getDefaultSellerSubmissionResult(status) {
  const isSuccess = status === SELLER_SUBMISSION_STATUSES.RECEIVED;
  const retryable =
    status === SELLER_SUBMISSION_STATUSES.NETWORK_ERROR ||
    status === SELLER_SUBMISSION_STATUSES.RATE_LIMITED ||
    status === SELLER_SUBMISSION_STATUSES.SERVICE_ERROR;

  return {
    ok: isSuccess,
    status,
    submissionId: null,
    sellerMessage:
      SELLER_RESULT_CODES[status] ||
      SELLER_RESULT_CODES[SELLER_SUBMISSION_STATUSES.UNKNOWN_ERROR],
    retryable,
    fieldErrors: [],
    errorCategory: isSuccess ? null : status,
    submittedAt: null,
  };
}

/**
 * Spanish field labels for future form rendering.
 * @returns {typeof SELLER_FIELD_LABELS_ES}
 */
export function getSellerSubmissionPublicFieldLabels() {
  return { ...SELLER_FIELD_LABELS_ES };
}
